/*
 * Garvin · Estado de campaña por fecha
 * Lee #garvin-campaign-config (snippet garvin-campaign-config) y pone en <html>
 * data-gc-state = pre | active | last-days | last-day | ended.
 * Modo prueba (solo vista previa / editor): ?gc_date=2026-11-08 · ?gc_date=off para quitarlo.
 */
(function () {
  var el = document.getElementById('garvin-campaign-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg || !cfg.start || !cfg.end) return;

  var root = document.documentElement;
  var KEY = 'garvin_gc_date';

  function readOverride() {
    if (!cfg.qa) return null;
    var v = null;
    try {
      var p = new URLSearchParams(window.location.search).get('gc_date');
      if (p === 'off') { sessionStorage.removeItem(KEY); return null; }
      if (p) { sessionStorage.setItem(KEY, p); v = p; } else { v = sessionStorage.getItem(KEY); }
    } catch (e) { return null; }
    if (!v) return null;
    // Solo fecha → mediodía local (evita dudas de cambio de hora)
    var t = Date.parse(/T/.test(v) ? v : v + 'T12:00:00');
    return isNaN(t) ? null : t;
  }

  function stateAt(ms) {
    var s = ms / 1000;
    if (s < cfg.start) return 'pre';
    if (s > cfg.end) return 'ended';
    if (cfg.lastDay && s >= cfg.lastDay) return 'last-day';
    if (cfg.lastDays && s >= cfg.lastDays) return 'last-days';
    return 'active';
  }

  var override = readOverride();
  var api = (window.GarvinCampaign = {
    id: cfg.id,
    pct: cfg.pct,
    vendors: cfg.vendors || [],
    collection: cfg.collection || '',
    preview: override !== null,
    state: null,
    isOn: function () { return api.state === 'active' || api.state === 'last-days' || api.state === 'last-day'; }
  });

  function apply() {
    var st = stateAt(override !== null ? override : Date.now());
    if (st === api.state) return;
    api.state = st;
    root.setAttribute('data-gc-state', st);
    try { document.dispatchEvent(new CustomEvent('garvin:campaign', { detail: { state: st } })); } catch (e) {}
  }

  apply();
  if (override === null) {
    setInterval(apply, 60000);
  } else if (window.console) {
    console.info('[Garvin] Campaña en modo prueba: ' + new Date(override).toString() + ' → ' + api.state);
  }
})();
